// import React, {FC, Suspense} from 'react'
// import {useAuth} from 'context/AuthProvider'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../layout/MasterLayout'
import HomePage from 'module/home/Home'
import MyAccountPage from 'module/my-account/MyAccount'
import UserManagementPage from 'module/user-management/UserManagement'
import OrderManagementPage from 'module/trade/OrderManagement'
import OrderDetailsPage from 'module/trade/OrderDetailsPage'
import {DEFAULT_TRADE_TAB} from 'module/trade/tradeRoutes'
import ProductCataloguePage from 'module/product-catalogue/ProductCatalogue'
import ProductListPage from 'module/product-catalogue/ProductList'
import AddProductPage from 'module/product-catalogue/AddProduct'
import ProductDetailsPage from 'module/product-catalogue/ProductDetailsPage'
import LedgerManagementPage from 'module/ledger/LedgerManagement'
import ManageUsersPage from 'module/user-management/manage-user/ManageUsers'
import ActivityManagement from 'module/activity-management'
import ProductPromotion from 'module/activity-management/product-promotion'
import CreatePromotionWrapper from 'module/activity-management/create-promotion'
import FestiveGreeting from 'module/activity-management/festive-greeting'
import CreateFestiveGreetingWrapper from 'module/activity-management/create-festive-greeting'
import AllTicketScreen from 'module/ticket/all-ticket'
import TicketDetail from 'module/ticket/all-ticket/TicketDetail'
import FaqPage from 'module/ticket/faq'
import Reports from 'module/reports'
import ReportListing from 'module/reports/ReportListing'
import TutorialWrapper from 'module/activity-management/tutorials'
import BulkUploadWrapper from 'module/activity-management/bulk-upload-management'
import BulkUploadForm from 'module/activity-management/bulk-upload-management/BulkUploadForm'
import ViewOrganisationWrapper from 'module/activity-management/view-organisation'
import ViewOrganisationForm from 'module/activity-management/view-organisation/ViewOrganisationForm'
import NotificationsPage from 'module/notifications'
import CropMasterWrapper from 'module/crop-master'
import AddCropPage from 'module/crop-master/AddCrop'
import CropDetailsPage from 'module/crop-master/CropDetailsPage'
// import ActivateUserPage from 'module/user-management/activate-user/ActivateUser'
// import TopBarProgress from 'react-topbar-progress-indicator'

/* type WithChildren = {
 children: React.ReactNode
} */

const PrivateRoutes = () => {
 //  const UploadModule = lazy(() => import('../modules/profile/ProfilePage'))

 //  const {isAuthReady, userData, isAuthenticated} = useAuth()
 return (
  <Routes>
   <Route element={<MasterLayout />}>
    {/* Redirect to Dashboard after success login/registartion */}
    <Route
     path='*'
     element={<Navigate to='/home-page' />}
    />
    <Route path='/home-page' element={<HomePage />} />
    <Route path='/my-account' element={<MyAccountPage />} />
    <Route
     path='/user-details/:id'
     element={<MyAccountPage />}
    />
    <Route path='/user-management'>
     <Route index element={<UserManagementPage />} />
     <Route
      path='manage-users'
      element={<ManageUsersPage />}
     />
    </Route>
    <Route path='/trade'>
     <Route
      index
      element={
       <Navigate
        to={`/trade/${DEFAULT_TRADE_TAB}`}
        replace
       />
      }
     />
     <Route
      path=':tabId'
      element={<OrderManagementPage />}
     />
     <Route
      path=':tabId/:orderId'
      element={<OrderDetailsPage />}
     />
    </Route>
    <Route path='/product-catalogue'>
     <Route index element={<ProductCataloguePage />} />
     <Route
      path='product-list'
      element={<ProductListPage />}
     />
     <Route
      path='add-product'
      element={<AddProductPage selectedProductId={null} />}
     />
     <Route
      path='product/:productId'
      element={<ProductDetailsPage />}
     />
    </Route>
    <Route
     path='ledger'
     element={<LedgerManagementPage />}
    />
    <Route path='activity-management'>
     <Route index element={<ActivityManagement />} />
     <Route path='product-promotion'>
      <Route index element={<ProductPromotion />} />
      <Route
       path='create-promotion'
       element={<CreatePromotionWrapper />}
      />
      <Route
       path='create-promotion/:id'
       element={<CreatePromotionWrapper />}
      />
     </Route>
     <Route path='festive-greeting'>
      <Route index element={<FestiveGreeting />} />
      <Route
       path='create-greeting'
       element={<CreateFestiveGreetingWrapper />}
      />
      <Route
       path='create-greeting/:id'
       element={<CreateFestiveGreetingWrapper />}
      />
     </Route>
     <Route path='bulk-upload-management'>
      <Route index element={<BulkUploadWrapper />} />
      <Route
       path='bulk-upload-form'
       element={<BulkUploadForm />}
      />
     </Route>
     <Route path='view-organisation'>
      <Route index element={<ViewOrganisationWrapper />} />
      <Route
       path='view-organisation-form'
       element={<ViewOrganisationForm />}
      />
      <Route
       path='view-organisation-form/:id'
       element={<ViewOrganisationForm />}
      />
     </Route>
    </Route>
    <Route path='all-tickets'>
     <Route index element={<AllTicketScreen />} />
     <Route path=':id' element={<TicketDetail />} />
    </Route>
    <Route path='crop-master'>
     <Route index element={<CropMasterWrapper />} />
     <Route
      path='add-crop'
      element={<AddCropPage cropId={null} />}
     />
     <Route
      path='crop/:cropId'
      element={<CropDetailsPage />}
     />
    </Route>
    <Route path='tutorials' element={<TutorialWrapper />} />
    <Route path='/faq' element={<FaqPage />} />
    <Route path='quick-links'>
     <Route index element={<Reports />} />
     <Route path='reports' element={<ReportListing />} />
    </Route>
    <Route
     path='/notifications'
     element={<NotificationsPage />}
    />
    {/* <Route
     path='/activate-user/:id'
     element={<ActivateUserPage />}
    /> */}
    <Route
     path='*'
     element={<Navigate to='/error/404' />}
    />
   </Route>
  </Routes>
 )
}

/* const SuspensedView: FC<WithChildren> = ({children}) => {
 TopBarProgress.config({
  barColors: {
   '0': '#000',
  },
  barThickness: 4,
  shadowBlur: 5,
 })
 return (
  <Suspense fallback={<TopBarProgress />}>
   {children}
  </Suspense>
 )
} */

export {PrivateRoutes}
